var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1773_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 3.95833C11.9747 3.95833 13.2956 4.46667 14.3372 5.45833L17.1914 2.60417C15.4581 0.991667 13.1956 0 10.4997 0C6.59141 0 3.21224 2.24167 1.56641 5.50833L4.89141 8.0875C5.67891 5.71667 7.89141 3.95833 10.4997 3.95833Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.075 10.2292C20.075 9.57499 20.0125 8.94166 19.9167 8.33333H10.5V12.0917H15.8917C15.65 13.325 14.95 14.375 13.9 15.0833L17.1208 17.5833C19 15.8417 20.075 13.2667 20.075 10.2292Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8875 11.9125C4.6875 11.3083 4.57083 10.6667 4.57083 10C4.57083 9.33333 4.68333 8.69166 4.8875 8.0875L1.5625 5.50833C0.883333 6.85833 0.5 8.38333 0.5 10C0.5 11.6167 0.883333 13.1417 1.56667 14.4917L4.8875 11.9125Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C13.2 20 15.4708 19.1125 17.1208 17.5792L13.9 15.0792C13.0042 15.6833 11.85 16.0375 10.5 16.0375C7.89167 16.0375 5.67917 14.2792 4.8875 11.9083L1.5625 14.4875C3.2125 17.7583 6.59167 20 10.5 20Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1773_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.697888b0ca39eebbc92bc2be43c8e5f7.svg";
export { ForwardRef as ReactComponent };